import type { CSSProperties } from 'react';
import type { IconName } from '@shared/components/SuperIcon/SuperIcon.types';
import type { ToastVariant } from '@shared/services/notifications/notifications.store';

interface VariantSpec {
  bg: string;
  border: string;
  iconColor: string;
  icon: IconName;
}

export const variantMap: Record<ToastVariant, VariantSpec> = {
  success: {
    bg: 'var(--color-surface)',
    border: 'rgba(143,181,115,0.4)',
    iconColor: 'var(--color-good)',
    icon: 'success',
  },
  error: {
    bg: 'var(--color-surface)',
    border: 'rgba(201,122,107,0.4)',
    iconColor: 'var(--color-bad)',
    icon: 'error',
  },
  warning: {
    bg: 'var(--color-surface)',
    border: 'rgba(212,168,87,0.4)',
    iconColor: 'var(--color-warn)',
    icon: 'warning',
  },
  info: {
    bg: 'var(--color-surface)',
    border: 'rgba(127,163,184,0.4)',
    iconColor: 'var(--color-info)',
    icon: 'info',
  },
};

export const stackStyle: CSSProperties = {
  position: 'fixed',
  top: 16,
  right: 16,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  zIndex: 50,
  pointerEvents: 'none',
  maxWidth: 'min(360px, calc(100vw - 32px))',
};

export function buildToastStyle(variant: ToastVariant): CSSProperties {
  const v = variantMap[variant];
  return {
    pointerEvents: 'auto',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    padding: 12,
    background: v.bg,
    border: '1px solid',
    borderColor: v.border,
    borderRadius: 'var(--radius-lg)',
    color: 'var(--color-text)',
    boxShadow: 'var(--shadow-medium)',
  };
}
